import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Variables } from '../base';

export const BADGE_ICON_SIZE = '16px';

export const entityBadgeTokens = {
    border: `var(--primary-mild, ${Variables.Colors.b300_l90})`,
    background: `var(--primary-x-mild, ${Variables.Colors.b300_l96})`,
    color: `var(--primary-2x-strong, ${Variables.Colors.b300_l62})`,
    font: `var(--label-md, 500 14px/1.2 Calibre, sans-serif)`,
    borderHover: `var(--primary-medium, ${Variables.Colors.b300_l76})`,
    backgroundHover: `var(--primary-mild, ${Variables.Colors.b300_l90})`,
    colorHover: `var(--primary-3x-strong, ${Variables.Colors.b300})`,
    textMild: `var(--text-mild, ${Variables.ThemeLight.TextMild})`,
    textStrong: `var(--text-strong, ${Variables.ThemeLight.TextStrong})`,
};

export const metricBadgeTokens = {
    border: `var(--border-1, ${Variables.ThemeLight.Border1})`,
    background: `var(--background-3, ${Variables.ThemeLight.Background3})`,
    color: `var(--text-medium, ${Variables.ThemeLight.TextMedium})`,
    borderHover: entityBadgeTokens.borderHover,
    backgroundHover: entityBadgeTokens.backgroundHover,
    colorHover: entityBadgeTokens.colorHover,
};

const entityBadgeLayoutStyles = css`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 32px;
    border-radius: 8px;
    font: ${entityBadgeTokens.font};
    white-space: nowrap;
    cursor: pointer;
    transition:
        background-color 120ms var(--ease-out, ease-out),
        border-color 120ms var(--ease-out, ease-out),
        color 120ms var(--ease-out, ease-out);

    svg {
        fill: currentColor;
    }
`;

export const entityBadgeBaseStyles = css`
    ${entityBadgeLayoutStyles}
    border: 1px solid ${entityBadgeTokens.border};
    background-color: ${entityBadgeTokens.background};
    color: ${entityBadgeTokens.color};
`;

export const entityBadgeHoverStyles = css`
    &:hover {
        border-color: ${entityBadgeTokens.borderHover};
        background-color: ${entityBadgeTokens.backgroundHover};
        color: ${entityBadgeTokens.colorHover};

        svg {
            fill: currentColor;
        }
    }
`;

export const metricBadgeBaseStyles = css`
    ${entityBadgeLayoutStyles}
    border: 1px solid ${metricBadgeTokens.border};
    background-color: ${metricBadgeTokens.background};
    color: ${metricBadgeTokens.color};
`;

export const metricBadgeHoverStyles = css`
    &:hover {
        border-color: ${metricBadgeTokens.borderHover};
        background-color: ${metricBadgeTokens.backgroundHover};
        color: ${metricBadgeTokens.colorHover};

        svg {
            fill: currentColor;
        }
    }
`;

export const entityBadgeActionButtonHoverStyles = css`
    border-color: ${entityBadgeTokens.borderHover};
`;

export const metricBadgeActionButtonHoverStyles = css`
    border-color: ${metricBadgeTokens.borderHover};
`;

export const EntityBadgeSymbol = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: inherit;

    svg {
        width: ${BADGE_ICON_SIZE};
        height: ${BADGE_ICON_SIZE};
        fill: currentColor;
    }
`;

export const LabeledValue = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    overflow: hidden;
`;

export const LabeledValuePrefix = styled.span`
    color: ${entityBadgeTokens.textMild};
    flex-shrink: 0;
`;

export const LabeledValueText = styled.span`
    color: ${entityBadgeTokens.textStrong};
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const metricBadgeLabeledValueHoverStyles = css`
    &:hover ${LabeledValuePrefix} {
        color: ${entityBadgeTokens.textMild};
    }

    &:hover ${LabeledValueText} {
        color: ${entityBadgeTokens.textStrong};
    }
`;
